import type { ReactNode } from 'react';

interface StepFrameProps {
  eyebrow?: string;
  title: string;
  body?: string;
  primaryCta?: ReactNode;
  secondaryCta?: ReactNode;
  children?: ReactNode;
  detected?: boolean;
  detectedLabel?: string;
}

export default function StepFrame({
  eyebrow, title, body, primaryCta, secondaryCta, children, detected, detectedLabel,
}: StepFrameProps) {
  return (
    <div className="mx-auto relative" style={{ maxWidth: 1040, padding: '64px 56px 80px' }}>
      <div
        className="absolute pointer-events-none"
        style={{ top: 60, left: -40, width: 120, height: 120, borderRadius: '50%', background: 'var(--color-peach)', opacity: 0.5 }}
      />
      <div
        className="absolute pointer-events-none"
        style={{ bottom: 80, right: -30, width: 90, height: 90, borderRadius: '50%', background: 'var(--color-mint)', opacity: 0.5 }}
      />
      <div
        className="absolute pointer-events-none"
        style={{ top: 200, right: 40, width: 60, height: 60, borderRadius: '50%', background: 'var(--color-lilac)', opacity: 0.5 }}
      />
      <div className="relative">
        {eyebrow && (
          <div
            className="inline-block font-bold uppercase mb-3.5"
            style={{ fontSize: 11.5, color: 'var(--color-ink-muted)', letterSpacing: '0.1em' }}
          >
            {eyebrow}
          </div>
        )}
        <h1
          className="font-display font-bold text-ink m-0"
          style={{ fontSize: 44, letterSpacing: '-0.025em', lineHeight: 1.08, maxWidth: 820 }}
        >
          {title}
        </h1>
        {body && (
          <p
            className="text-ink-soft leading-[1.55] m-0 mt-3.5"
            style={{ fontSize: 17, maxWidth: 620 }}
          >
            {body}
          </p>
        )}
        {children && <div className="mt-10">{children}</div>}
        <div className="flex items-center flex-wrap mt-9" style={{ gap: 14 }}>
          {primaryCta}
          {secondaryCta}
          <div className="flex-1" />
          {detected && (
            <div
              className="flex items-center gap-2 font-semibold"
              style={{
                padding: '7px 14px',
                background: 'oklch(0.94 0.07 150)',
                color: 'oklch(0.34 0.1 150)',
                borderRadius: 999,
                fontSize: 12.5,
              }}
            >
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12" />
              </svg>
              {detectedLabel ?? 'Detected'}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
